import * as React from 'react';
import * as _ from 'lodash';
import classNames from 'classnames';
import CheckBox from '../../components/PageLayout/CheckBox';
import NewScopeCategoryInput from '../../components/NewScope/newScopeCategoryInput.js';
export default function () {
    function onClick1(qtCategory, qtCategoryIndex, activeQtCategoryIndex, event) {
        this.setQtCategoryActive(event);
    }
    function onMouseOver2(qtCategory, qtCategoryIndex, activeQtCategoryIndex, event) {
        this.onMouseOver(event);
    }
    function onMouseLeave3(qtCategory, qtCategoryIndex, activeQtCategoryIndex, event) {
        this.onMouseLeave(event);
    }
    function onChecked4(qtCategory, qtCategoryIndex, activeQtCategoryIndex) {
        this.categoryCheckboxClick(qtCategory.id);
    }
    function onClick5(qtCategory, qtCategoryIndex, activeQtCategoryIndex) {
        this.deleteQtCategory();
    }
    function onClick6(qtCategory, qtCategoryIndex, activeQtCategoryIndex) {
        this.editQtCategory();
    }
    function onClick7(qtCategory, qtCategoryIndex, activeQtCategoryIndex) {
        this.editQtCategoryImage();
    }
    function onChange8(qtCategory, qtCategoryIndex, activeQtCategoryIndex, newValue) {
        this.categoryNameChange(newValue);
    }
    function scopeQtCategoryQtCategoryIndexActiveQtCategoryIndex9() {
        var qtCategory = this.props.qtCategory;
        var qtCategoryIndex = this.props.qtCategoryIndex;
        var activeQtCategoryIndex = this.props.activeQtCategoryIndex;
        return React.createElement('li', {
            'data-index': qtCategoryIndex,
            'className': classNames('assign-sidebar-list__item', { 'assign-sidebar-list__item--active': qtCategoryIndex === activeQtCategoryIndex }, { 'assign-sidebar-list__item--isDraggedOver': this.state.isDraggedOver }, { 'assign-sidebar-list__item--draggable': qtCategory.name !== 'All' }),
            'onClick': onClick1.bind(this, qtCategory, qtCategoryIndex, activeQtCategoryIndex),
            'onMouseOver': onMouseOver2.bind(this, qtCategory, qtCategoryIndex, activeQtCategoryIndex),
            'onMouseLeave': onMouseLeave3.bind(this, qtCategory, qtCategoryIndex, activeQtCategoryIndex)
        }, qtCategory.name !== 'All' ? React.createElement(CheckBox, {
            'checked': qtCategory.enabled,
            'text': qtCategory.enabled ? 'Enabled' : 'Disabled',
            'className': 'assign-sidebar-list__item-checkbox ui-svg-checkbox--secondary',
            'onChecked': onChecked4.bind(this, qtCategory, qtCategoryIndex, activeQtCategoryIndex),
            'key': '957'
        }) : null, qtCategory.name !== 'All' ? React.createElement('button', {
            'className': 'ui-icon-remove2 assign-sidebar-list__item-remove',
            'onClick': onClick5.bind(this, qtCategory, qtCategoryIndex, activeQtCategoryIndex),
            'key': '1274'
        }) : null, qtCategory.name !== 'All' ? React.createElement('button', {
            'className': 'ui-icon-edit assign-sidebar-list__item-edit',
            'onClick': onClick6.bind(this, qtCategory, qtCategoryIndex, activeQtCategoryIndex),
            'key': '1416'
        }) : null, qtCategory.bgImageUrl && !qtCategory.editing ? React.createElement('div', {
            'className': 'assign-sidebar-list__item-image',
            'style': this.getImageStyle(qtCategory.bgImageUrl),
            'key': '1551'
        }) : null, !qtCategory.bgImageUrl || qtCategory.editing ? React.createElement('div', {
            'className': 'assign-sidebar-list__item-add-button',
            'key': '1714'
        }, React.createElement('button', {
            'className': 'ui-button--add2 ui-button--add2--bordered ui-button',
            'onClick': onClick7.bind(this, qtCategory, qtCategoryIndex, activeQtCategoryIndex)
        }, React.createElement('span', { 'className': 'ui-button-icon ui-button-icon--add2' }), React.createElement('span', { 'className': 'ui-button-text' }, 'Add Icon'))) : null, qtCategory.name && !qtCategory.editing ? React.createElement('span', {
            'className': 'assign-sidebar-list__item-title',
            'key': '2072'
        }, qtCategory.name) : null, !qtCategory.name || qtCategory.editing ? React.createElement(NewScopeCategoryInput, {
            'qtCategory': qtCategory,
            'className': 'ui-input ui-input--gray',
            'placeholder': 'Name',
            'value': qtCategory.name,
            'onChange': onChange8.bind(this, qtCategory, qtCategoryIndex, activeQtCategoryIndex),
            'key': '2193'
        }) : null);
    }
    return scopeQtCategoryQtCategoryIndexActiveQtCategoryIndex9.apply(this, []);
}